<template>
  <div class="message">
    <div class="message__user_ava" v-if="sender.id">
      <img v-if="sender.avatar" :src="sender.avatar" alt="avatar" />
      <SvgIcon v-else size="80%" name="user-light" />
    </div>
    <div class="message__content">
      <div class="message__user_name" v-if="sender.id">
        {{ sender.username }}
      </div>
      <div class="message__text">
        <div
          v-if="!attachment"
          class="message__text_wrap"
          v-html="formatedText"
        />

        <app-btn
          v-else
          link
          class="pa-2 message__text_wrap"
          @click.stop="openImg(attachment.url)"
        >
          <img
            :src="attachment.thumb_url"
            :alt="`Attachment ${attachment.id}`"
          />
        </app-btn>
        <div v-if="time" class="message__date">
          {{ time | dayjs("DD.MM.YYYY HH:mm") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import showImage from "@/services/common/showImage";
import { createTextLinks } from "@/core/util/helpers";

export default {
  props: {
    sender: {
      type: Object,
      required: true
    },
    attachment: {
      type: Object,
      required: false
    },
    time: {
      type: [Number, String],
      required: false
    },
    text: String
  },

  computed: {
    formatedText() {
      return createTextLinks(this.text);
    }
  },

  methods: {
    async openImg(url) {
      await showImage(url);
    }
  }
};
</script>

<style lang="scss">
.message {
  border-radius: 2px;
  padding: 16px 0;
  display: flex;
  flex: 1 1 auto;
  max-width: 80%;
  width: 100%;

  &__content {
    margin-left: 10px;
    margin-right: 0;
    order: 2;

    .message_me & {
      margin-right: 10px;
      margin-left: 0;
      order: 1;
    }
  }

  &:not(.message_me) {
    align-self: flex-start;
    justify-content: flex-start;
  }

  &_me {
    align-self: flex-end;
    justify-content: flex-end;
  }

  &__date {
    font-size: 10px;
    color: gray;
  }

  &__text {
    position: relative;
    margin-left: 16px;

    text-align: left;

    a {
      display: inline;
      color: rgba(#fff, 0.7);
      font-weight: normal;
      border-bottom: 1px solid #fff;
      transition: 0.3s;

      &:hover {
        color: #fff;
      }
    }

    .message_me & {
      margin-left: 0;
      margin-right: 16px;

      text-align: right;
    }

    &:after {
      content: "";
      display: block;
      position: absolute;
      width: 16px;
      height: 16px;
      left: -16px;
      top: 0;
      border-right: 8px solid rgba(#fff, 0.15);
      border-top: 8px solid rgba(#fff, 0.15);
      border-left: 8px solid transparent;
      border-bottom: 8px solid transparent;

      .message_me & {
        left: auto;
        right: -16px;
        border-left: 8px solid rgba(#7c9fff, 0.15);
        border-top: 8px solid rgba(#7c9fff, 0.15);
        border-right: 8px solid transparent;
        border-bottom: 8px solid transparent;
      }
    }

    &_wrap {
      padding: 10px 20px 15px 20px;
      background: rgba(#fff, 0.15);
      border-radius: 6px;
      border-top-left-radius: 0;

      display: inline-block;
      text-align: left;
      word-break: break-all;

      .message_me & {
        background: rgba(#7c9fff, 0.15);
        border-radius: 6px;
        border-top-right-radius: 0;
      }
    }

    img {
      display: block;
      font-weight: normal;
      text-transform: none;
      max-height: 150px;
    }
  }

  &__user {
    &_ava {
      width: 100%;
      max-width: 40px;
      height: 40px;
      flex: 1 0 auto;
      border: 2px solid;
      background: #7f8492;
      transition: 0.2s;
      order: 1;
      display: flex;
      align-items: center;
      justify-content: center;

      img,
      svg {
        display: block;
        width: 100%;
      }

      svg {
        margin: 0;
        width: 80%;
      }

      .btn__content {
        justify-content: center;
      }

      .message_me & {
        order: 2;
      }
    }

    &_name {
      font-weight: 800;
      font-size: 14px;
      line-height: 15px;
      margin-bottom: 8px;

      .message_me & {
        text-align: right;
      }
    }

    .message_referee & {
      &_ava {
        background: darken(#fbc33e, 25%);
        border-color: #fbc33e;
        &:hover {
          border-color: lighten(#fbc33e, 25%);
          box-shadow: 0px 0px 10px #fbc33e;
        }
      }

      &_name {
        @include breakpoint("xs-only") {
          color: #fbc33e;
        }
      }
    }

    .message_red & {
      &_ava {
        background: darken(#e72f31, 25%);
        border-color: #e72f31;

        &:hover {
          border-color: lighten(#e72f31, 25%);
          box-shadow: 0px 0px 10px #e72f31;
        }
      }

      &_name {
        @include breakpoint("xs-only") {
          color: #e72f31;
        }
      }
    }

    .message_blue & {
      &_ava {
        background: darken(#1480b2, 10%);
        border-color: #1480b2;

        &:hover {
          border-color: lighten(#1480b2, 45%);
          box-shadow: 0px 0px 10px #1480b2;
        }
      }

      &_name {
        @include breakpoint("xs-only") {
          color: #1480b2;
        }
      }
    }
  }

  &.message_system {
    max-width: 100%;

    .message__date {
      display: none;
    }

    .message__content,
    .message__text_wrap {
      width: 100%;
    }

    .message__text {
      &:after {
        display: none;
      }

      &_wrap {
        background: transparent;
        padding: 0px;
        text-align: center;
        color: #7f8492;
      }
    }
  }
}

@include breakpoint("xs-only") {
  .team-columns {
    .message {
      flex-direction: column;

      &__user_ava {
        display: none;
      }

      &__content {
        margin: 0;
      }
    }
  }
}
</style>
